/* eslint-disable @atlaskit/design-system/no-nested-styles */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

import IconButton from '@atlaskit/button/icon/button';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CrossIcon from '@atlaskit/icon/core/cross';
import { token } from '@atlaskit/tokens';

const buttonsContainerStyles = css({
	display: 'flex',
	position: 'absolute',
	flexShrink: 0,
	insetBlockStart: '100%',
	insetInlineEnd: 0,
	marginBlockStart: token('space.075'),
});

const buttonWrapperBaseStyles = css({
	boxSizing: 'border-box',
	width: token('space.400'),
	zIndex: 200,
	backgroundColor: token('elevation.surface.overlay'),
	borderRadius: token('radius.medium'),
	boxShadow: token('elevation.shadow.overlay'),
	font: token('font.body'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
	'&:last-child': {
		marginInlineStart: token('space.050'),
	},
	'& > button': {
		backgroundColor: token('elevation.surface.overlay'),
	},
	'& > button:hover': {
		backgroundColor: token('elevation.surface.overlay.hovered'),
	},
	'& > button:active': {
		backgroundColor: token('elevation.surface.overlay.pressed'),
		color: token('color.text'),
	},
});

interface ButtonsProp {
	confirmButtonLabel: string;
	cancelButtonLabel: string;
	onMouseDown: () => void;
	onCancelClick: (event: React.MouseEvent<HTMLElement>) => void;
	testId?: string;
}

const Buttons: ({
	confirmButtonLabel,
	cancelButtonLabel,
	onMouseDown,
	onCancelClick,
	testId,
}: ButtonsProp) => JSX.Element = ({
	confirmButtonLabel,
	cancelButtonLabel,
	onMouseDown,
	onCancelClick,
	testId,
}: ButtonsProp) => (
	<div css={buttonsContainerStyles}>
		<div css={[buttonWrapperBaseStyles]} tabIndex={-1}>
			<IconButton
				type="submit"
				icon={(iconProps) => <CheckMarkIcon {...iconProps} size="small" />}
				onMouseDown={onMouseDown}
				label={confirmButtonLabel}
				testId={testId && `${testId}--confirm`}
			/>
		</div>
		<div css={[buttonWrapperBaseStyles]} tabIndex={-1}>
			<IconButton
				icon={(iconProps) => <CrossIcon {...iconProps} size="small" />}
				label={cancelButtonLabel}
				onClick={onCancelClick}
				onMouseDown={onMouseDown}
				testId={testId && `${testId}--cancel`}
			/>
		</div>
	</div>
);
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Buttons;
